import { render } from "./ButtonHeaderIconTooltip.vue?vue&type=template&id=01dbbf37"
import script from "./ButtonHeaderIconTooltip.vue?vue&type=script&lang=js"
export * from "./ButtonHeaderIconTooltip.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__